import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const DownloadIcon = (props) => {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 17.855 17.871" {...props} >
      <path
        d="M299.109,437.545l-4.191,4.191a1.273,1.273,0,0,0,1.8,1.8l4.082-4.191a2.545,2.545,0,0,0-3.6-3.6l-4.082,4.19a3.818,3.818,0,1,0,5.4,5.4l3.982-3.973"
        transform="matrix(0.719, -0.695, 0.695, 0.719, -511.163, -101.502)" fill="none" stroke="currentColor"
        strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
    </SvgIcon>
  );
};

DownloadIcon.propTypes = {}

DownloadIcon.defaultProps = {}

export default DownloadIcon;
